import React from 'react'
import {Panel} from 'react-bootstrap'
import classnames from 'classnames';

const AddStaff = ({onAddStaffClicked, open, row}) => {

  return (
    <div col-md={12}>
      <Panel className={classnames('text-center', 'add-staff', {open: open})} onClick={() => onAddStaffClicked(row)}>
        <button className="grey-ghost-btn btn btn-default">Add new staff member</button>
      </Panel>
    </div>
  );
};

export default AddStaff



// WEBPACK FOOTER //
// ./src/components/my-staff/add-staff.jsx